import React from 'react';
import EstadisticasRankingPartidosTabla from './EstadisticasRankingPartidosTabla';
import styled from 'styled-components/macro';

const EstadisticasRankingPartidos =(props)=>{
  return(
      <>
        {props.data[0].data[0].lisrank.length === 0? (
            <>Sin información</>
          ) : (
            <EstRanking>
              {/* {props.data.map((x)=>{
                  return( <EstadisticasRankingPartidosTabla data={x} nomenclator={props.nomenclator}/>)
              })} */}
              <EstadisticasRankingPartidosTabla data={props.data[0]} nomenclator={props.nomenclator}/>
            </EstRanking>
          )}
      </>
    );
};

const EstRanking = styled.section`
width:100%;
  margin-top: 6px;
  background-color: white;
  box-shadow: 0px -7px 18px rgb(0 0 0 / 6%);
  overflow: auto;
  border: 5px solid white;
`;

export default EstadisticasRankingPartidos;